import { addDays } from "date-fns";
import { INormalizedChartDate } from "../types";
import { createEmptyEntry } from "./createEmptyEntry";

export const addDaysAfterDate = (count: number, startDate: Date): INormalizedChartDate[] => {
  if (count <= 0) return [];
  
  const result: INormalizedChartDate[] = [];
  for (let i = 1; i <= count; i++) {
    result.push(createEmptyEntry(addDays(startDate, i), true));
  }
  return result;
};